import { PropsWithChildren } from 'react'

import { useLexicalEditable } from '@lexical/react/useLexicalEditable'
import { useBoolean } from 'ahooks'
import { Button, Tooltip } from 'antd'

import { useEditor } from '../../hooks/useEditor'

import { MenuButtonProps } from './interface'

export const MenuButton = ({
  ref,
  actived,
  alwaysEnabled,
  disabled: externalDisabled,
  tooltip,
  children,
  onClick,
  // 接收 Dropdown 组件传递进来的事件
  ...restProps
}: PropsWithChildren<MenuButtonProps>) => {
  const editor = useEditor()
  const editable = useLexicalEditable()
  const disabled = !alwaysEnabled && (externalDisabled || !editable)

  const [open, openActions] = useBoolean(false)

  return (
    <Tooltip
      open={open}
      title={tooltip}
      trigger='hover'
      onOpenChange={openActions.set}
    >
      <Button
        {...restProps}
        ref={ref}
        disabled={disabled}
        type={actived ? 'link' : 'text'}
        onClick={event => {
          onClick?.(event)
          openActions.setFalse()
          editor?.focus()
        }}
      >
        {children}
      </Button>
    </Tooltip>
  )
}
